import React, { useState } from "react";
import "../styles/contact.css";

export default function ContactSection() {
  const [contactStatus, setContactStatus] = useState("idle");
  const reviewItems = [
    "System and data flow gaps",
    "Manual spreadsheet and file-based processes",
    "Reconciliation and control risks",
    "Operational workflow automation opportunities",
    "Platform, integration and reporting roadmap",
  ];

  const handleContactSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch("https://getform.io/f/apjxxjoa", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        throw new Error("Submission failed");
      }

      form.reset();
      setContactStatus("success");
    } catch (error) {
      setContactStatus("error");
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="contact-card">
        <div className="contact-header">
          <span className="eyebrow">Start with a review</span>
          <h2>Review the data flows behind your systems, reporting and workflows.</h2>
          <p>
            Share the systems, manual processes or reconciliation issues you want to fix.
            We will come back with practical next steps.
          </p>
          <div className="review-scope-panel" aria-label="What a data platform review can assess">
            <h3>What we can review</h3>
            <ul>
              {reviewItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleContactSubmit}>
          <div className="contact-row">
            <label>
              Name
              <input type="text" name="name" placeholder="Jane Doe" required />
            </label>
            <label>
              Email
              <input type="email" name="email" placeholder="jane@company.com" required />
            </label>
          </div>
          <div className="contact-row">
            <label>
              Company
              <input type="text" name="company" placeholder="Company name" />
            </label>
            <label>
              Timeline
              <input type="text" name="timeline" placeholder="Q3, next month, etc." />
            </label>
          </div>
          <label className="contact-message">
            What are you trying to achieve?
            <textarea
              name="message"
              rows="4"
              placeholder="Tell us about your systems, reporting issues or platform goals."
            />
          </label>

          <button type="submit" className="primary-btn contact-submit">
            Request data platform review
          </button>
          {contactStatus === "success" && (
            <p className="contact-feedback success">
              Thanks, your message is sent. We will be in touch shortly.
            </p>
          )}
          {contactStatus === "error" && (
            <p className="contact-feedback error">
              Something went wrong. Please email nurlan.alizada@dataapparatus.com.au.
            </p>
          )}
          <p className="contact-note">
            Prefer email?{" "}
            <a href="mailto:nurlan.alizada@dataapparatus.com.au">
              nurlan.alizada@dataapparatus.com.au
            </a>
          </p>
        </form>
      </div>
    </section>
  );
}
